module.exports = __webpack_public_path__ + "img/header-weddingRingsTensionRings.be29b3b.jpg";